import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { NavbarLandingPage } from "../../../components";
import { useSettings } from "@/context/SettingsProvider";

export const LandingPageLayout = (props) => {
  const settingsStore = useSettings();
  const { settings } = settingsStore;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>{settings.site_title}</title>
        <meta name="description" content={settings.site_description} />
        <link rel="icon" href={settings.site_icon} />
      </Helmet>

      <NavbarLandingPage />
      <main className="flex-grow">{props.children}</main>
      <footer className="border-t py-6 bg-gray-50 dark:bg-gray-900">
        <div className="container mx-auto px-4 text-center text-gray-600 dark:text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} Rituely. {t("footer.rights")}
          </p>
          <div className="flex justify-center gap-4 mt-4 text-sm">
            <a href="/privacy" className="hover:text-primary hover:underline">
              {t("footer.privacy")}
            </a>
            <span>•</span>
            <a href="/terms" className="hover:text-primary hover:underline">
              {t("footer.terms")}
            </a>
          </div>
          <p className="text-sm mt-4">{t("footer.builtWith")}</p>
        </div>
      </footer>
    </div>
  );
};
